export default __webpack_public_path__ + "5df0a78b46612c76a00069fb7ae0c070.png";